import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import SignInFormComponent from "../../components/signInForm/signInForm";

export default function SignInPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign In | Prepal</title>
        <meta name="description" content="Sign in to your Prepal account to access personalized test preparation tools." />
        <meta name="keywords" content="Prepal, sign in, login, test prep, education" />
        <meta name="author" content="Prepal Team" />
      </Helmet>
      <SignInFormComponent />
    </>
  );
}